"use strict";

var _interopRequireWildcard = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _history = _interopRequireDefault(require("../utils/history"));

var _createStore = _interopRequireDefault(require("../store/createStore"));

var _jsxFileName = "/opt/build/repo/season-frontend/src/hub/app-configurator.jsx";
const initialState = window.___INITIAL_STATE__;
const store = (0, _createStore.default)(initialState, _history.default);

const HubConfigurator = App => {
  return () => {
    return /*#__PURE__*/React.createElement(_reactRedux.Provider, {
      store: store,
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(App, {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13,
        columnNumber: 9
      }
    }));
  };
};

var _default = HubConfigurator;
exports.default = _default;